import { useEffect, useState } from "react";
import { getAcTenantId, subscribeAcTenantId } from "../utils/acTenantId";

/**
 * Current `AC_TENANT_ID` cookie value; updates when the cookie changes
 * (polled / focus / visibility). Use as a React Query / effect dependency
 * or remount key so AI Plan data refreshes for the new tenant.
 */
export function useAcTenantId(): string {
  const [tenantId, setTenantId] = useState(getAcTenantId);

  useEffect(() => {
    setTenantId(getAcTenantId());
    return subscribeAcTenantId((next) => {
      setTenantId(next);
    });
  }, []);

  return tenantId;
}
